var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute"},[(_vm.isButton_(_vm.scrId, 'CC'))?_c('sf-button',{attrs:{"line":"","icon":"file","onClick":_vm.saveAction}},[_vm._v(" "+_vm._s(_vm.getMessage_('QWCC001131'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }